// extracted by mini-css-extract-plugin
module.exports = {"page":"Welcome_page__36tH3","text":"Welcome_text__vZSu9","textEmphasized":"Welcome_textEmphasized__2w1lL"};